import { useQuery } from '@tanstack/react-query';
import type { StudentDetailsWithIdDto } from '../../../models/users/students/student-details.dto';
import type { StudentUpdateFormWithIdDto } from '../../../models/users/students/student-update-form.dto';
import apiRequest from '../../../services/apiWrapper';
import { mapStringToSimpleDate } from '../../../services/mapStringToSimpleDate';

interface GetStudentsForParentProps {
  enabled?: boolean;
  excludeArchived?: boolean;
  isStudyingInCurrentYear?: boolean;
}

async function getStudentsForParent(
  excludeArchived: boolean,
  isStudyingInCurrentYear?: boolean
) {
  const conditionalParam =
    typeof isStudyingInCurrentYear === 'boolean'
      ? `&isStudyingInCurrentYear=${isStudyingInCurrentYear}`
      : '';

  const response = await apiRequest.get<{
    students: StudentDetailsWithIdDto[];
  }>(
    `/api/users/parents/profile/students?excludeArchived=${excludeArchived}${conditionalParam}`
  );

  return response.data;
}

function mapStudentsToStudentUpdateFormDto(data: {
  students: StudentDetailsWithIdDto[];
}): StudentUpdateFormWithIdDto[] {
  return data.students.map((student) => ({
    ...student,
    birthDate: mapStringToSimpleDate(student.birthDate),
  }));
}

export function useGetStudentsForParent({
  enabled = true,
  excludeArchived = false,
  isStudyingInCurrentYear,
}: GetStudentsForParentProps) {
  return useQuery({
    queryKey: ['parent-students', excludeArchived, isStudyingInCurrentYear],
    queryFn: () =>
      getStudentsForParent(excludeArchived, isStudyingInCurrentYear),
    select: (data) => mapStudentsToStudentUpdateFormDto(data),
    enabled,
  });
}
